// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logoImg {
  height: 3rem;
  width: 12rem;
  cursor: pointer;
}

.accessButton {
  margin-top: -5px;
}

.ulNav {
  display: flex;
  justify-content: space-between;
  list-style-type: none;
  margin-bottom: 0;
  padding: 5px;
  /* overflow: hidden; */
  background-color: #fff;
  box-shadow: 0px 8px 16px -6px rgba(0, 0, 0, 0.1);
}
.container {
  max-width: 100% !important;
}
.liNav {
  float: left;
}

.liNav p {
  display: block;
  color: black;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  margin-bottom: 0;
}

/* Change the link color to #111 (black) on hover */
.liNav p:hover {
  background-color: #bad7e9;
  color: #181818;
  border-radius: 5px;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 200px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropDownUl {
  position: relative;
  display: inline-block;
}

.dropDownUl-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  z-index: 1;
}

.dropDownUl:hover .dropDownUl-content {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar/navbar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,gDAAgD;AAClD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".logoImg {\n  height: 3rem;\n  width: 12rem;\n  cursor: pointer;\n}\n\n.accessButton {\n  margin-top: -5px;\n}\n\n.ulNav {\n  display: flex;\n  justify-content: space-between;\n  list-style-type: none;\n  margin-bottom: 0;\n  padding: 5px;\n  /* overflow: hidden; */\n  background-color: #fff;\n  box-shadow: 0px 8px 16px -6px rgba(0, 0, 0, 0.1);\n}\n.container {\n  max-width: 100% !important;\n}\n.liNav {\n  float: left;\n}\n\n.liNav p {\n  display: block;\n  color: black;\n  text-align: center;\n  padding: 14px 16px;\n  text-decoration: none;\n  margin-bottom: 0;\n}\n\n/* Change the link color to #111 (black) on hover */\n.liNav p:hover {\n  background-color: #bad7e9;\n  color: #181818;\n  border-radius: 5px;\n}\n\n.dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: #f9f9f9;\n  min-width: 200px;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n}\n\n.dropdown:hover .dropdown-content {\n  display: block;\n}\n\n.dropDownUl {\n  position: relative;\n  display: inline-block;\n}\n\n.dropDownUl-content {\n  display: none;\n  position: absolute;\n  background-color: #f9f9f9;\n  min-width: 160px;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  padding: 12px 16px;\n  z-index: 1;\n}\n\n.dropDownUl:hover .dropDownUl-content {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
